// Public (no login) page reached from the unsubscribe link in a marketing email. Confirms first, then
// opts the address out of marketing emails only — invoices and order updates keep coming.
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Wordmark from '../components/Wordmark.jsx';
import { readUnsubscribe, confirmUnsubscribe, resubscribe } from '../api/marketing.js';

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const t = params.get('t') || '';
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    readUnsubscribe(t)
      .then((r) => setState({ email: r.email, done: r.unsubscribed }))
      .catch(() => setState({ error: 'This link isn’t valid. Reply to any of our emails and we’ll take you off the list.' }));
  }, [t]);
  const act = (fn, done) => () => fn(t).then(() => setState((s) => ({ ...s, done }))).catch(() => setState((s) => ({ ...s, error: 'Something went wrong — please try again.' })));

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-raised px-4">
      <div className="w-full max-w-md rounded-xl border border-line bg-surface p-8 text-center shadow-sm">
        <div className="flex justify-center"><Wordmark /></div>
        {state.loading ? (
          <p className="mt-6 text-sm text-text-muted">Loading…</p>
        ) : state.error ? (
          <p className="mt-6 text-sm text-text-secondary">{state.error}</p>
        ) : state.done ? (
          <>
            <h1 className="mt-6 text-lg font-semibold text-text-primary">You’re unsubscribed</h1>
            <p className="mt-2 text-sm text-text-secondary">
              <strong>{state.email}</strong> won’t receive TEAMM8 marketing emails any more. You’ll still get invoices and updates about your orders.
            </p>
            <button onClick={act(resubscribe, false)} className="mt-5 text-sm font-medium text-accent hover:underline">Changed your mind? Resubscribe</button>
          </>
        ) : (
          <>
            <h1 className="mt-6 text-lg font-semibold text-text-primary">Unsubscribe from marketing emails?</h1>
            <p className="mt-2 text-sm text-text-secondary">
              <strong>{state.email}</strong> will stop receiving promotions, lookbooks and news from TEAMM8 Wholesale. Invoices and order updates aren’t affected.
            </p>
            <button onClick={act(confirmUnsubscribe, true)} className="mt-5 rounded-md bg-accent px-5 py-2 text-sm font-semibold text-white hover:bg-accent-hover">Unsubscribe</button>
          </>
        )}
      </div>
    </div>
  );
}
